import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const maintenanceInitialValues = {
  task: "",
  observation: "",
  days: [],
  startDate: undefined,
  endDate: undefined,
  assignedId: undefined,
  urgency: undefined,
  inventoryItemIds: [],
};

export const maintenanceValidationSchema = Yup.object({
  task: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  observation: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  days: Yup.array().min(1, FIELD_REQUIRED_MESSAGE),
  startDate: Yup.string().optional(),
  endDate: Yup.string().optional(),
  assignedId: Yup.number().optional(),
  urgency: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  inventoryItemIds: Yup.array().of(Yup.number()).min(1, FIELD_REQUIRED_MESSAGE),
});

export const editMaintenanceValidationSchema = Yup.object({
  task: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  observation: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  startDate: Yup.string().optional(),
  endDate: Yup.string().optional(),
  assignedId: Yup.number().optional(),
  urgency: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  inventoryItemIds: Yup.array().of(Yup.number()).min(1, FIELD_REQUIRED_MESSAGE),
});

export type MaintenanceValues = typeof maintenanceInitialValues;
